import Vue from 'vue';

const success = (context, response, file) => {
  let filename = file.name.substring(file.name.lastIndexOf("/") + 1);
  let fileURL = window.URL.createObjectURL(new Blob([response]));
  let fileLink = document.createElement('a');

  fileLink.href = fileURL;
  fileLink.setAttribute('download', filename);
  document.body.appendChild(fileLink);
  fileLink.click();

  context.smallLoading = false;
};

const failed = (context, error) => {
  context.showToasterError(error);
  context.smallLoading = false;
};

export default (context, file) => {
  return Vue.$http.get(`checklists/download-file/${file.id}`, {responseType: 'arraybuffer'})
    .then(response => {
      if (response && response.status === 200) {
        success(context, response.data, file);
      } else {
        failed(context, response);
      }
    }).catch(error => {
      if (error) {
        failed(context, error);
      }
  });
}




// WEBPACK FOOTER //
// ./src/app/services/checklist_group/downloadMultimedia.js